import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import {jwtDecode} from "jwt-decode";

interface UserContextType {
    role: string | null;
    setRole: (role: string | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider = ({ children }: UserProviderProps) => {
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
        const token = localStorage.getItem("d_c_c_t"); 
        ////console.log(token)
        
        if (token) {
            try {
                const decodedToken: any = jwtDecode(token);
                const userRole = decodedToken?.groupName; 

                if (userRole) {
                    setRole(userRole);
                }
            } catch (error) {
                console.error("Failed to decode token", error);
            }
        }
    }, []);

    return (
        <UserContext.Provider value={{ role,setRole }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserRole = (): UserContextType => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUserRole must be used within a UserProvider");
    }
    return context;
};
